"use client";

import { Header } from "@/components/layout/Header/Header";
import { Cursor } from "@/components/common/Cursor/Cursor";
import { useEffect, useRef, useState } from "react";
import { useRefStore } from "../../store/ref-store";
import { Dialog } from "@/components/common/Dialog/Dialog";
import ScrollManager from "@/components/common/ScrollManager/ScrollManager";
import ResizeReLoader from "@/utils/ResizeReLoader";

export function LayoutHolder({ children }) {
  const contentRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (
      typeof window !== undefined &&
      window.matchMedia("(min-width: 768px)").matches
    ) {
      setIsMobile(false);
      useRefStore.setState({ isMobile: false });
    }
    if (
      typeof window !== undefined &&
      window.matchMedia("(max-width: 767px)").matches
    ) {
      setIsMobile(true);
      useRefStore.setState({ isMobile: true });
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      useRefStore.setState({ fromPopState: true });
    };

    window.addEventListener("popstate", handler);

    return () => {
      window.removeEventListener("popstate", handler);
    };
  }, []);

  return (
    <>
      {!isMobile && <Cursor />}
      <ResizeReLoader />
      <Header />
      <Dialog />
      <ScrollManager />
      <main
        ref={contentRef}
        style={{
          backgroundColor: "var(--background)",
        }}
        className="mainWebWrapper"
      >
        {children}
      </main>
    </>
  );
}
